module.exports = __webpack_public_path__ + "img/Hero Image.266338ca.png";